<template>
  <v-layer ref="layer" :config="config">
    <v-image :config="imgWidget" />
    <v-image :config="imgTips" />
    <v-image :config="imgSloganTitle" />
    <v-image :config="imgPictureBg" />
    <v-image :config="imgPicture" />
    <v-image :config="imgSloganSimple" />
    <v-image ref="file-select" :config="imageBtnSelectPic" />
    <v-image ref="poster-btn" :config="imageGeneratePoster" />
    <v-text :config="textConfig" />
  </v-layer>
</template>

<script>
import ImageWidget from '@/assets/event-ic-widget-02.png'
import ImageTips from '@/assets/event-ic-bg-pic-tips.png'
import ImageSloganTitle from '@/assets/event-ic-bg-slogan-title.png'
import ImageSloganSimple from '@/assets/event-ic-slogan-simple.png'
import ImageBtnSelectPic from '@/assets/event-ic-btn-01.png'
import ImageGeneratePoster from '@/assets/event-ic-btn-02.png'

import { help } from './help'

export default {
  mixins: [help],
  props: {
    picture: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      config: {
        visible: false
      },
      imgTips: {
        image: null,
        x: this.transformWH(70),
        y: this.transformWH(230)
      },
      imgWidget: {
        image: null,
        x: this.transformWH(0),
        y: this.transformWH(286)
      },
      imgSloganTitle: {
        image: null,
        x: this.transformWH(50),
        y: this.transformWH(380),
        scaleX: 0.8,
        scaleY: 0.8,
        rotation: -6
      },
      imgSloganSimple: {
        image: null,
        x: this.transformWH(430),
        y: this.transformWH(900)
      },
      imageBtnSelectPic: {
        image: null,
        x: this.transformWH(142),
        y: this.transformWH(1000)
      },
      imageGeneratePoster: {
        image: null,
        x: this.transformWH(142),
        y: this.transformWH(1130)
      },
      imgPictureBg: {
        x: this.transformWH(30),
        y: this.transformWH(530),
        width: this.transformWH(597),
        height: this.transformWH(384),
        fill: 'rgb(120,120,120)',
        rotation: -6
      },
      imgPicture: {
        image: null,
        x: this.transformWH(30),
        y: this.transformWH(530),
        width: this.transformWH(597),
        height: this.transformWH(384),
        rotation: -6
      },
      textConfig: {
        text: '温馨提示：建议选择横板照片哦！',
        fill: '#fff',
        fontSize: 12,
        x: this.transformWH(210),
        y: this.transformWH(1260)
      }
    }
  },
  watch: {
    picture(src) {
      if (!src) {
        return
      }
      this.getImage(src).then((img) => {
        this.imgPicture.image = img
      }).catch(err => {
        console.error('err ', err)
      })
    }
  },
  async mounted() {
    await this.init()
    await this.initEvent()
  },
  methods: {
    async init() {
      try {
        await this.placeImage(ImageTips, 'imgTips')
        await this.placeImage(ImageWidget, 'imgWidget')
        await this.placeImage(ImageSloganTitle, 'imgSloganTitle')
        await this.placeImage(ImageSloganSimple, 'imgSloganSimple')
        await this.placeImage(ImageBtnSelectPic, 'imageBtnSelectPic')
        await this.placeImage(ImageGeneratePoster, 'imageGeneratePoster')
      } catch (error) {
        console.error(error)
      }
    },
    async startAnimation() {},
    async hide() {
      this.config.visible = false
    },
    async show() {
      this.config.visible = true
    },
    async getFileBtnPosition() {
      return this.$refs['file-select'].getNode().attrs
    },
    async initEvent() {
      try {
        const posterBtn = this.$refs['poster-btn'].getNode()
        posterBtn.on('touchstart', () => {
          this.$emit('generate')
        })
        // support for desktop
        posterBtn.on('click', () => {
          this.$emit('generate')
        })
        const stage = posterBtn.getStage()

        posterBtn.on('mouseenter', function() {
          stage.container().style.cursor = 'pointer'
        })
        posterBtn.on('mouseleave', function() {
          stage.container().style.cursor = 'default'
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
